<template>
    <div>
        <router-view />
    </div>
</template>
<script>

export default {
    name: "PettyCaseIndex",
    data() {
        return {}
    },
    created() {

    },
    methods: {

    },
}

</script>